import React, { useEffect, useRef, useState } from "react";
import { MenuIcon, XIcon } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { company, images } from "../i18n/translations";
const links = [{
  id: "inicio",
  href: "#inicio"
}, {
  id: "nosotros",
  href: "#nosotros"
}, {
  id: "productos",
  href: "#productos"
}, {
  id: "capacidad",
  href: "#capacidad"
}, {
  id: "galeria",
  href: "#galeria"
}, {
  id: "contacto",
  href: "#contacto"
}] as const;
export function Navbar() {
  const {
    t,
    lang,
    setLang
  } = useLanguage();
  const [open, setOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const previousScrollY = useRef(0);
  useEffect(() => {
    const onScroll = () => {
      const currentScrollY = window.scrollY;
      const isScrollingDown = currentScrollY > previousScrollY.current;
      if (currentScrollY < 24 || !isScrollingDown) {
        setIsVisible(true);
      } else if (currentScrollY - previousScrollY.current > 5) {
        setIsVisible(false);
      }
      previousScrollY.current = currentScrollY;
    };
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <header className={"fixed top-0 inset-x-0 z-50 bg-white shadow-md transition-transform duration-300 " + (isVisible || open ? "translate-y-0" : "-translate-y-full")} data-id="element-48" data-mp="jn6s0lugnnu1">
      <nav className="max-w-content mx-auto px-4 sm:px-6 h-[72px] flex items-center justify-between" aria-label="Principal" data-id="element-49" data-mp="3n57349vbc9bv">
        <a href="#inicio" className="flex shrink-0" aria-label={company.name} data-id="element-50" data-mp="vmb4h3ox3wg">
          <img src={images.logo} alt="GRANSACA" className="h-14 w-auto" width={168} height={63} data-id="element-51" data-mp="5mw1jjx2cb9e" />
        </a>

        {/* Desktop links */}
        <ul className="hidden lg:flex items-center gap-7" data-id="element-52" data-mp="39bplwvq3n8p0">
          {links.map(l => <li key={l.id} data-id="element-53" data-mp="31b9qk6f3ahx8">
              <a href={l.href} className="text-[15px] font-medium text-navy transition-colors hover:text-orange" data-id="element-54" data-mp="31ai0tc86beev">
                {t.nav[l.id]}
              </a>
            </li>)}
        </ul>

        <div className="flex items-center gap-3" data-id="element-55" data-mp="3b2xf9zk9hkv0">
          <LangSelector solid={true} lang={lang} setLang={setLang} data-id="element-56" data-mp="36319pvvx1ldc" />

          <a href="#contacto" className="hidden md:inline-flex items-center rounded-sm bg-orange px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-orange-dark" data-id="element-57" data-mp="2ic5mlc2enecf">
            {t.nav.cotizar}
          </a>

          <button type="button" onClick={() => setOpen(v => !v)} className="lg:hidden p-2 text-navy" aria-label="Menú" aria-expanded={open} data-id="element-58" data-mp="2sbwi9h2pbze3">
            {open ? <XIcon size={26} data-id="element-59" data-mp="7m765btdurp3" /> : <MenuIcon size={26} data-id="element-60" data-mp="2ljceidrrwr6" />}
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {open && <div className="lg:hidden bg-white border-t border-slate-100 shadow-lg" data-id="element-61" data-mp="a3r0zffgjulb">
          <ul className="px-4 py-3" data-id="element-62" data-mp="f4ess3bigfgl">
            {links.map(l => <li key={l.id} data-id="element-63" data-mp="f1ivmh7hlut7">
                <a href={l.href} onClick={() => setOpen(false)} className="block py-3 text-navy font-medium border-b border-slate-100 last:border-0" data-id="element-64" data-mp="14vus3ceyki0">
                  {t.nav[l.id]}
                </a>
              </li>)}
          </ul>
          <div className="px-4 pb-4" data-id="element-65" data-mp="xt1ucbuhampf">
            <a href="#contacto" onClick={() => setOpen(false)} className="block text-center rounded-sm bg-orange px-4 py-3 text-sm font-semibold text-white" data-id="element-66" data-mp="xw7k7taxlsm7">
              {t.nav.cotizar}
            </a>
          </div>
        </div>}
    </header>;
}
function LangSelector({
  solid,
  lang,
  setLang
}: {
  solid: boolean;
  lang: "es" | "en";
  setLang: (l: "es" | "en") => void;
}) {
  const base = "px-2 py-1 text-xs font-bold uppercase tracking-wide rounded-sm transition-colors";
  return <div className={"flex items-center gap-0.5 rounded-sm border p-0.5 " + (solid ? "border-slate-200" : "border-white/40")} role="group" aria-label="Language selector" data-id="element-67" data-mp="3k22jkuf7xolf">
      {(["es", "en"] as const).map(l => {
      const active = lang === l;
      return <button key={l} type="button" onClick={() => setLang(l)} aria-pressed={active} className={base + " " + (active ? "bg-orange text-white" : solid ? "text-navy hover:bg-slate-100" : "text-white hover:bg-white/10")} data-id="element-68" data-mp="bm93uhspoh5f">
            {l}
          </button>;
    })}
    </div>;
}